import React from "react"

const QuotesContext = React.createContext({})

const { Provider, Consumer } = QuotesContext

export { Provider, Consumer, QuotesContext }
